import { Form } from '@unform/web';
import { TableCell, TableContainer } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  background-color: #ffffff;

  position: relative;
`;

export const WrapperFullScreen = styled(Wrapper)`
  min-height: 100%;

  padding: 0 2.5rem;

  overflow-y: auto;

  .MuiTableCell-root {
    font-size: 2rem;
    /* font-size: 2.5rem; */
  }

  .MuiFormControl-root {
    margin-top: 0.6rem;
  }

  .mayWidh {
    width: 18rem;
  }

  .maySizeStatus {
     font-size: 1.5rem;
  }

  .MuiTableCell-sizeSmall {
    padding: 4px 20px 4px 10px;
  }

`;

export const Header = styled.header`
  margin-bottom: 2rem;
  width: 100%;

  display: flex;
  justify-content: flex-end;
`;

export const Container = styled(Form)`
  flex: 1;
  width: 100%;

  display: flex;
  flex-direction: column;

  .MuiFilledInput-inputMarginDense {
    padding-top: 6px;
  }

  .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel) {
    margin-top: 3px;
  }

  .MuiFilledInput-root,
  .MuiFilledInput-root:hover {
    background-color: transparent !important;
  }
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  padding: 2rem;

  position: absolute;

  top: -1.8rem;
  right: 15rem;

  .inputPerPage {
    max-width: 7rem;

    margin-left: 1rem;
    margin-right: 2rem;
  }

  input {
    text-align: center;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-left: 2rem;
`;

export const WrapperContainer = styled(TableContainer)`
  height: ${({ maxHeight }) => maxHeight};
  max-height: 100%;

  position: relative;

  .MuiTableRow-root.Mui-selected,
  .MuiTableRow-root.Mui-selected:hover {
    background-color: rgba(0, 0, 0, 0.01) !important;
    box-shadow: 0px 3px 5px 0px rgb(0 0 0 / 30%);
  }

  tbody.MuiTableBody-root tr:nth-child(even) {
    background-color: rgba(0, 0, 0, 0.015);
  }


@media (max-width: 600px) {
  .MuiTableCell-sizeSmall {
    padding: 4px 20px 4px 10px;
  }
}

  /* .MuiTableCell-sizeSmall {
    padding: 8px 18px 8px 18px;
  } */

        /* padding: 6px 24px 6px 16px; */

`;


export const CustomTableCell = styled(TableCell)`
  /* padding: 4px 8px; */

  @media (max-width: 600px) {
    padding: 2px 4px; /* Padding reduzido para telas menores */
  }

  /* background-color: #f5f5f5;
  color: #333;  */
`;

export const CustomTableCellStatus = styled(TableCell)`
  font-size: 1.5rem;

`;


export const CustomTableCellFooter = styled(TableCell)`
  color: #333;
  font-size: 1.5rem;
  .MuiTableCell-root {
    font-size: 1.5rem;
  }
`;
